const FormResources = {

    form_data:{
        staffing_scenario_id:   '',
        group_id:               '',
        description:            '',
        order:                  '',
        frequency_week:         '',
        daily_minutes:          '',
        annual_minutes:         '', 
    },

    form_format:[  
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Staffing Scenario:',
            model_name: 'staffing_scenario_id',
            ref:        'staffing_scenario_id_input',
            ref_alt:    'staffing_scenario_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Housekeeping Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Order:',
            model_name: 'order',
            ref:        'order_input',
            ref_alt:    'order_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Frequency/Week:',
            model_name: 'frequency_week',
            ref:        'frequency_week_input',
            ref_alt:    'frequency_week_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Daily Minutes:',
            model_name: 'daily_minutes',
            ref:        'daily_minutes_input',
            ref_alt:    'daily_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Annual Minutes:',
            model_name: 'annual_minutes',
            ref:        'annual_minutes_input',
            ref_alt:    'annual_minutes_input_alt',
            required:   true,
        },
    ]

}

export default FormResources;